import React, { FC, useEffect } from 'react';
import { Card } from '@components/atoms/Card';
import { Typography } from '@components/atoms/Typography';
import { useTranslation } from 'react-i18next';
import styles from './SafePaymentsCard.module.css';
import { useGetAllPaymentMethods } from '@services/useGetAllPaymentMethods';
import { useData } from '@hooks/useData';

export const SafePaymentsCard: FC = () => {
    const { allPaymentMethods } = useData();
    const { request: requestAllPaymentMethods } = useGetAllPaymentMethods();
    const { t, i18n } = useTranslation();

    const translations = {
        title: t('safe-payments-card-component.title'),
        imageAlt: t('safe-payments-card-component.image-alt'),
    };

    // call services, if we don't have the information yet
    useEffect(() => {
        !allPaymentMethods && requestAllPaymentMethods();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allPaymentMethods, i18n.language]);

    return (
        <Card classes={styles['safe-payments-card']}>
            <Typography fontSize="16" fontWeight="800" classes="mb-2">
                {translations.title}
            </Typography>
            <div className="pt-1">
                {allPaymentMethods?.data?.map(
                    (item, index) =>
                        item.image?.src && (
                            <img key={`payment-method-${index}`} className="px-1" src={item.image.src} alt={item.name} />
                        )
                )}
            </div>
        </Card>
    );
};
